module.exports = "<div class=\"wrapper\">\r\n    <div class=\"sidebar\" data-color=\"blue\" data-image=\"\">\r\n        <sidebar-cmp></sidebar-cmp>\r\n        <div class=\"sidebar-background\" style=\"background-image: url(/assets/img/sidebar-5.jpg)\"></div>\r\n    </div>\r\n    <div class=\"main-panel\">\r\n        <navbar-cmp></navbar-cmp>\r\n         <dashboard-cmp></dashboard-cmp>\r\n        <footer-cmp></footer-cmp>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.html
// module id = 188
// module chunks = 1